import React, { useContext } from 'react';
import { Card } from 'react-bootstrap';
import { TranslationContext } from '../../../contexts/TranslationContext';
import { EditProductLineRequest, IProductLine2, ProductLineClient, ProductLineLanguage } from '../../../services/WebApiClient';
import { useClient } from '../../../util/useClient';
import { useState2 } from '../../../util/useState2';

export function ProductLineDetaulsAdmin(props: {

    onChange: () => void;
    productLine: Readonly<IProductLine2>
}) {


    const tc = useContext(TranslationContext);


    const client = useClient(ProductLineClient);
    const translations = useState2(() => props.productLine.productLineLanguages.map(pll => {

        return {
            id: pll.languageId,
            productLineLanguage: { ...pll },
            isChanged: false
        };
    }));
    const selectedTranslationIndex = useState2(0);
    const selectedTranslation = translations.value[selectedTranslationIndex.value];


    async function submit(evt: React.FormEvent) {
        evt.preventDefault();
        try {
            await client.editProductLine(
                props.productLine.id,
                new EditProductLineRequest({
                    productLineLanguages: translations.value
                        .filter(l => l.isChanged)
                        .map(l => new ProductLineLanguage(l.productLineLanguage))
                })
            );
        }
        finally {
            props.onChange();
        }
    }
    function setName(newName: string) {
        const newTranslations = [...translations.value];
        newTranslations[selectedTranslationIndex.value] = {
            ...selectedTranslation,
            productLineLanguage: {
                ...selectedTranslation.productLineLanguage,
                name: newName
            },
            isChanged: true
        };
        translations.set(newTranslations);
    }
    function setDesc(newDesc: string) {
        const newTranslations = [...translations.value];
        newTranslations[selectedTranslationIndex.value] = {
            ...selectedTranslation,
            productLineLanguage: {
                ...selectedTranslation.productLineLanguage,
                description: newDesc
            },
            isChanged: true
        };
        translations.set(newTranslations);
    }

    return (
        <Card>
            <Card.Body>
                <Card.Title>Text</Card.Title>

                <form onSubmit={submit}>
                    <div className="form-group">
                        <label htmlFor="product-line-language">
                            {tc.translator("admin edit product line language", "Sprog")}
                        </label>
                        <select value={selectedTranslationIndex.value}
                            className="form-control"
                            id="product-line-language"
                            onChange={evt => selectedTranslationIndex.set(parseInt(evt.target.value))}
                        >
                            {translations.value.map((l, index) => (
                                <option value={index} key={l.id}>
                                    {l.productLineLanguage.languageName}
                                </option>
                            ))}
                        </select>
                    </div>
                    <div className="form-group">
                        <label htmlFor="product-line-name">
                            {tc.translator("admin edit product line name", "Navn")}
                        </label>
                        <input type="text" className="form-control"
                            id="product-line-name"
                            value={selectedTranslation.productLineLanguage.name}
                            onChange={evt => setName(evt.target.value)}
                            placeholder={tc.translator("admin edit product line name", "Navn")}
                        />
                    </div>

                    <div className="form-group">
                        <label htmlFor="product-line-desc">
                            {tc.translator("admin edit product line desc", "Beskrivelse")}
                        </label>
                        <textarea className="form-control"
                            id="product-line-desc"
                            rows={4}
                            value={selectedTranslation.productLineLanguage.description}
                            onChange={evt => setDesc(evt.target.value)}
                            placeholder={tc.translator("admin edit product line desc", "Beskrivelse")}
                        />
                    </div>

                    <button className="btn btn-primary">
                        {tc.translator("admin edit product line button", "Gem")}
                    </button>
                </form>
            </Card.Body>
        </Card>

    );
}
